var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-link',{staticClass:"cell-hierachy-link",attrs:{"to":{ path: `${_vm.prefix}${_vm.quick.clientPath ?? _vm.quick.path}/${_vm.value.id}` }}},[(!_vm.mergedData['hide-tag'])?_c('span',{staticClass:"cell-hierachy-title"},[_vm._v(_vm._s(_vm.$_(_vm.quick.title)))]):_vm._e(),_c('b-badge',{staticClass:"hierachy-badge",attrs:{"variant":"info","pill":""}},[_c('iv-icon',{attrs:{"icon":_vm.quick.icon}}),(_vm.value.name)?_c('span',[_vm._v("\n            "+_vm._s(_vm.$_(_vm.value.name))+"\n        ")]):(_vm.value.id)?_c('iv-request',{attrs:{"server":{
                path: `${_vm.quick.path}`,
                method: `R`,
                params: {
                    where: {
                        id: _vm.value.id,
                    },
                    select: {
                        name: true,
                    },
                },
            }},scopedSlots:_vm._u([{key:"@query",fn:function({ query }){return [(query.data?.results?.[0])?_c('span',[_vm._v("\n                    "+_vm._s(_vm.$_(query.data?.results?.[0]?.name))+"\n                ")]):_vm._e()]}}])}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }